import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PermissionPayload, DeletePayload } from '../../../component/DashboardScreens/components/rbac.models';
import { environment } from '../../../../environments/environment';

// Permission doesn't follow the plain single-entity CRUD shape
// (add takes a *list* wrapped in { permission: [...] }, get takes
// an empty body), so it gets its own small service rather than
// extending RbacCrudService.
@Injectable({ providedIn: 'root' })
export class PermissionService {
  private endpoint = '/Permission';
  apiBase:string = environment.apiURL
  
  constructor(
    private http: HttpClient,
  ) {}

  private get url(): string {
    return `${this.apiBase}${this.endpoint}`;
  }

  add(payload: PermissionPayload): Observable<any> {
    return this.http.post(this.url, payload);
  }
  update(payload: PermissionPayload): Observable<any> {
    return this.http.put(this.url, payload);
  }

  get(): Observable<any> {
    return this.http.get(this.url);
  }

  delete(id: string): Observable<any> {
    const payload: DeletePayload = { id };
    return this.http.request('delete', this.url, { body: payload });
  }
}
